import type { ReactElement } from 'react';
import { forwardRef, useCallback, useState } from 'react';

import type { IInput } from '../Input';

import Input from '../Input';

export interface IInputPassword extends IInput {}

const InputPassword = forwardRef<HTMLInputElement, IInputPassword>(
  (props: IInputPassword, ref): ReactElement => {
    const [showPassword, setShowPassword] = useState(false);

    const handleChangeType = useCallback(() => setShowPassword(!showPassword), [showPassword]);

    return (
      <Input
        {...props}
        ref={ref}
        iconButton={showPassword ? 'eye_hide' : 'eye_show'}
        onClickButton={handleChangeType}
        type={showPassword ? 'text' : 'password'}
      />
    );
  },
);

export default InputPassword;
